import React from 'react';
import classNames from 'classnames';
import { Cascader as AntdCascader } from 'antd';
import { ConfigContext } from '../config-provider';
import { Icon } from '../icon';
import getIcons from '../select/utils/iconUtil';
import { FieldNamesType, FilledFieldNamesType } from 'antd/lib/cascader';
import warning from 'antd/es/_util/warning';
import AntdConfigProvider from 'antd/es/config-provider';
import AnimationContext from '../config-provider/AnimationContext';
export const Cascader = (props) => {
    const { prefixCls: customizePrefixCls, size, suffixIcon, expandIcon, className, dropdownClassName, showArrow = true } = props;
    const { defaultOpen, onDropdownVisibleChange } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('cascader', customizePrefixCls);
    const animation = React.useContext(AnimationContext);
    const [isOpen, setIsOpen] = React.useState(defaultOpen !== undefined ? defaultOpen : false);
    if (process.env.NODE_ENV !== 'production')
        warning(!('theme' in props), 'Cascader', '`theme` is deprecated in 3.0.0.');
    // ===================== Icons =====================
    const { removeIcon, clearIcon } = getIcons({
        ...props,
        prefixCls
    });
    const newsuffixIcon = !suffixIcon ? React.createElement(Icon, { type: 'chevron--down' }) : suffixIcon;
    const newexpandIcon = !expandIcon ? React.createElement(Icon, { type: 'chevron--right' }) : expandIcon;
    const mergedOnDropdownVisibleChange = (open) => {
        setIsOpen(open);
        if (typeof onDropdownVisibleChange === 'function') {
            onDropdownVisibleChange(open);
        }
    };
    const newClassName = classNames({
        [`${prefixCls}-normal`]: true,
        [`${prefixCls}-xs`]: size === 'xs'
    }, className);
    const mergeDropdownClassName = classNames(dropdownClassName, {
        [`${prefixCls}-glassmorphism`]: !!animation?.glassmorphism
    });
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', customizePrefixCls), ...restContext },
        React.createElement(AntdCascader, { ...props, className: newClassName, suffixIcon: newsuffixIcon, expandIcon: newexpandIcon, removeIcon: removeIcon, dropdownClassName: mergeDropdownClassName, clearIcon: clearIcon, showArrow: showArrow, onDropdownVisibleChange: mergedOnDropdownVisibleChange })));
};
// export default withConfigProvider(Cascader);
export default Cascader;
